import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import TrendDiscovery from "./pages/TrendDiscovery";
import ContentPipeline from "./pages/ContentPipeline";
import AssetLibrary from "./pages/AssetLibrary";
import Approval from "./pages/Approval";
import Distribution from "./pages/Distribution";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";
import BrandIntelligence from "./pages/BrandIntelligence";
import CanvasDesigner from "./pages/CanvasDesigner";
import BrandGuardrailsPage from "./pages/BrandGuardrails";
import AIHumanizer from "./pages/AIHumanizer";
import NotFound from "./pages/not-found/Index";
import PWAInstallPrompt from "./components/PWAInstallPrompt";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <PWAInstallPrompt />
      <HashRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/trends" element={<TrendDiscovery />} />
          <Route path="/pipeline" element={<ContentPipeline />} />
          <Route path="/assets" element={<AssetLibrary />} />
          <Route path="/approval" element={<Approval />} />
          <Route path="/distribution" element={<Distribution />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/brand" element={<BrandIntelligence />} />
          <Route path="/canvas" element={<CanvasDesigner />} />
          <Route path="/guardrails" element={<BrandGuardrailsPage />} />
          <Route path="/humanizer" element={<AIHumanizer />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
